import React from 'react';
import Layout from '../../../components/Layout/admin';

const GenericApprovalList = ({ children }: any) => {
  return <Layout>{children}</Layout>;
};

export default GenericApprovalList;
